import React from "react";
import IconInspectionSuccess from "../../photos/car/icon-inspection-success.component";
import {
  Button,
  Container
} from '@mui/material';

const InspectionSuccessNative = (Props: any) => {
  const {
    isConnected,
    onClose,
  } = Props;
  return (
    <div>
      <div className='header-background'/>
      <div className="success">
        <div className="success__title">
          <h3>Suas vistorias foram salvas!</h3>
        </div>
        <div className="success__content">
          {!isConnected && 
            <Container data-testid="no-connect-msg">
              <span>Assim que houver conexão, as vistorias serão enviadas para nosso sistema. 
                Agora é só aguardar!</span>
            </Container>
          }
          {isConnected &&
            <Container data-testid="connect-msg">
              <span>Suas vistorias foram salvas e o envio para o nosso sistema já foi iniciado. 
              Agora é só aguardar!</span>
            </Container>
          }
        </div>
        <IconInspectionSuccess color="#D40020"/>
     </div>
     <div>
      <div className="float-footer">
        <Button
          className="primary-button"
          fullWidth
          onClick={onClose}
          data-testid="finish-button"
        >Encerrar</Button>
        </div>
      </div>
    </div>
  );
};

export default InspectionSuccessNative;
